import { createEffect, createEvent, createStore } from "effector";
import { PlayerConfig, playerConfigVoid } from "../../../types/alice-bob";

export const $playerConfig = createStore<PlayerConfig>(playerConfigVoid)